var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hisworks" }, [
    _c("div", { staticClass: "worksWarp" }, [
      _c(
        "div",
        { staticClass: "worksMain" },
        [
          _c("RealTitle", {
            attrs: { titleInfo: _vm.titleInfo, backPath: _vm.backPath },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "worksContent" }, [
            _c("div", { staticClass: "hisWorkTabs" }, [
              _c(
                "div",
                { staticClass: "hisWorkTabsItemsWarp" },
                _vm._l(_vm.hisWorksTypeInfo.title, function (i, j) {
                  return _c(
                    "div",
                    {
                      key: j,
                      class: [
                        "hisWorkTabsItems",
                        _vm.itemsActNum === j ? "act" : "",
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.items(j)
                        },
                      },
                    },
                    [_c("div", [_vm._v(_vm._s(i))])]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "awardsTabsWarp" },
                _vm._l(_vm.hisWorksTypeInfo.awards, function (i, j) {
                  return _c(
                    "div",
                    {
                      key: j,
                      class: [
                        "awardsTabs",
                        _vm.awardsActNum === j ? "act" : "",
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.awards(j)
                        },
                      },
                    },
                    [_c("span", [_vm._v(" " + _vm._s(i))])]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "hisWorksVideoRender" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "videoRenderWarp" },
                [
                  _vm.list.length > 0
                    ? _vm._l(_vm.list, function (i, j) {
                        return _c(
                          "div",
                          {
                            key: j,
                            staticClass: "videoRenderItem",
                            on: {
                              click: function ($event) {
                                return _vm.jump(_vm.e)
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: i.imgSrc
                                  ? i.imgSrc
                                  : require("@/assets/img/img202.jpg"),
                                alt: "暂无图片",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(i.title))]),
                          ]
                        )
                      })
                    : [_vm._v("\n              暂无数据\n            ")],
                ],
                2
              ),
            ]),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "renderTitle" }, [
      _c("span", [_vm._v("视频列表")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }